<template>
  <LsModal title="Are you sure you want to decline the pro?" track-id="leads_decline_modal">
    <template #body>
      <p>
        Declining this pro is permanent. You will not be able to message this pro and hire this pro
        once you decline them.
      </p>
      <LsInput
        v-model="reason"
        type="textarea"
        label="What is the reason for declining the pro?"
        track-id="leads_decline_modal-reason"
        placeholder="Additional details..."
        name="reason"
        maxlength="1024"
      />
    </template>
    <template #footer>
      <LsButton
        text="decline pro"
        track-id="leads_decline_modal-decline_pro"
        :loading="customerLeads.loadingStatus.isUpdating"
        @click="declinePro"
      />
    </template>
  </LsModal>
</template>

<script>
import { LsButton, LsInput, LsModal } from '@/components/common';
import VueTypes from 'vue-types';
import { mapActions, mapState } from 'vuex';
import { CUSTOMER_LEADS__DECLINE_PRO } from '@/store/types';

export default {
  name: 'LeadsDeclineModal',
  components: {
    LsButton,
    LsInput,
    LsModal,
  },
  props: {
    propertyId: VueTypes.number.isRequired,
    customerLeadId: VueTypes.number.isRequired,
    contactId: VueTypes.number.isRequired,
  },
  data() {
    return {
      reason: '',
    };
  },
  computed: {
    ...mapState(['customerLeads']),
  },
  methods: {
    ...mapActions([CUSTOMER_LEADS__DECLINE_PRO]),
    declinePro() {
      const { propertyId, contactId, customerLeadId } = this;
      this[CUSTOMER_LEADS__DECLINE_PRO]({
        propertyId,
        customerLeadId,
        contactId,
        reason: this.reason || null,
        onSuccess: this.onSuccess,
      });
    },
    onSuccess() {
      this.$router.replace({ name: 'services' });
      this.$parent.close();
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
  line-height: 28px;
}
</style>
